import { Divider, Stack } from "@mui/material";
import { z } from "zod";
import { findTenantInHierarchy, type OrganisationHierarchy } from "../../../api/organisations.types";
import type { ScimAdGroup } from "../../../api/scimAdGroups";
import type { ScimPermission } from "../../../api/scimPermissions";
import { PageTitle, PageWrapper } from "../../../shared/Page";
import { useParsedParams } from "../../../shared/useParsedParams";
import { usePrivacyDocumentTitle } from "../../../shared/usePrivacyDocumentTitle";
import { DISPLAYED_ROLES } from "../Roles";
import { ScimMappingInput } from "./ScimMappingInput";
import { Navigate } from "react-router";

type ScimMappingFieldsProps = {
  organisationHierarchy: OrganisationHierarchy;
  adGroups: Array<ScimAdGroup>;
  permissions: Array<ScimPermission>;
};

export const ScimMappingFields = ({ organisationHierarchy, adGroups, permissions }: ScimMappingFieldsProps) => {
  usePrivacyDocumentTitle("Sidebar.ScimMapping");
  const parsedParams = useParsedParams(z.object({ tenantId: z.string() }));

  const tenant = findTenantInHierarchy(organisationHierarchy, parsedParams.tenantId);

  if (!tenant) return <Navigate to={`../${organisationHierarchy.id}`} relative="path" replace />;

  return (
    <PageWrapper>
      <Stack sx={{ gap: 4 }}>
        <Stack
          sx={{
            flexWrap: "wrap",
            alignItems: "baseline",
            flexDirection: "row",
            gap: 3,
            justifyContent: "space-between",
          }}
        >
          <PageTitle title={tenant.organizationName} />
        </Stack>

        <Stack divider={<Divider />} sx={{ gap: 3, maxWidth: 700 }}>
          {DISPLAYED_ROLES.map(role => (
            <ScimMappingInput
              key={role}
              tenantId={parsedParams.tenantId}
              role={role}
              adGroups={adGroups}
              permissions={permissions}
            />
          ))}
        </Stack>
      </Stack>
    </PageWrapper>
  );
};
